module.exports = __webpack_public_path__ + "img/citysuites.9ed35dd0.jpg";